import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoashtavinayakdarshancabservice() {



const cardData = {
  keyword: "Mumbai to Ashtavinayak Darshan Cab Service",
  heading: "Lotus Cab: Mumbai to Ashtavinayak Darshan Cab Service",

  headingDescription:
    "Lotus Cab offers reliable and affordable Mumbai to Ashtavinayak Darshan Cab Service for devotees seeking a comfortable and spiritually fulfilling pilgrimage journey. The Ashtavinayak Yatra includes visits to eight sacred Ganpati temples located across Maharashtra, and our chauffeur-driven AC sedans, SUVs, luxury vehicles, and mini buses ensure safe and smooth travel throughout the trip. Whether you are planning a one-day darshan, a two-day temple circuit, or a family pilgrimage tour, we provide flexible one-way and round-trip packages at transparent per-kilometer rates. Our professional drivers are experienced in long-distance temple routes and ensure punctual arrivals for darshan schedules. Vehicles are well-maintained, sanitized, and GPS-enabled for secure highway travel. With 24/7 booking support and easy online reservations, Lotus Cab guarantees a peaceful and stress-free Ashtavinayak Yatra from Mumbai.",

  top: "Top Ashtavinayak Temples to Visit with Lotus Cab",

  topPlaces: [
    {
      title: "Mayureshwar Temple – Morgaon",
      description:
        "Mayureshwar Temple in Morgaon is considered the starting and ending point of the Ashtavinayak Yatra. Dedicated to Lord Ganesha, this temple holds immense spiritual importance among devotees. Pilgrims from Mumbai prefer comfortable AC cab services for early morning darshan. The serene village surroundings create a peaceful atmosphere for worship. SUV and sedan options provide relaxed long-distance travel. Lotus Cab ensures timely temple visits and smooth route planning."
    },
    {
      title: "Siddhivinayak Temple – Siddhatek",
      description:
        "Siddhivinayak Temple at Siddhatek is located on the banks of the Bhima River and is believed to fulfill devotees’ wishes. The temple is accessible via scenic rural roads, making chauffeur-driven cab service ideal for safe travel. Families prefer spacious SUVs for group comfort. AC vehicles ensure relaxed pilgrimage journeys. Flexible waiting time allows unhurried darshan. Lotus Cab ensures a smooth and devotional experience."
    },
    {
      title: "Ballaleshwar Temple – Pali",
      description:
        "Ballaleshwar Temple in Pali is the only Ashtavinayak temple named after a devotee of Lord Ganesha. This temple attracts thousands of pilgrims every year. Comfortable one-way and round-trip cab options from Mumbai make travel convenient. Professional drivers ensure safe highway navigation. Ideal for family and group temple tours."
    },
    {
      title: "Varadvinayak Temple – Mahad",
      description:
        "Varadvinayak Temple is known for granting blessings and fulfilling wishes. Devotees often combine multiple temple visits in a single trip. Budget and luxury cab options are available for flexible planning. AC comfort enhances travel during long journeys."
    },
    {
      title: "Chintamani Temple – Theur",
      description:
        "Chintamani Temple in Theur is famous for relieving worries and bringing peace. Pilgrims prefer organized cab services for timely darshan. Lotus Cab ensures comfortable travel and flexible itinerary planning."
    },
    {
      title: "Girijatmaj Temple – Lenyadri",
      description:
        "Located in a cave complex, Girijatmaj Temple requires a short climb, making it essential to have a comfortable journey beforehand. SUV cabs are ideal for this destination."
    },
    {
      title: "Vighnahar Temple – Ozar",
      description:
        "Vighnahar Temple symbolizes removal of obstacles. AC vehicles ensure relaxed travel between temples."
    },
    {
      title: "Mahaganapati Temple – Ranjangaon",
      description:
        "Mahaganapati Temple is the final temple in the Ashtavinayak circuit. Pilgrims prefer comfortable return journeys to Mumbai with Lotus Cab."
    }
  ],

  services: [
    {
      name: "Mumbai to Ashtavinayak Cab",
      description:
        "Reliable cab service from Mumbai to complete the Ashtavinayak Yatra comfortably. AC sedans and SUVs available. Professional chauffeurs ensure safe temple route travel. Transparent per-km pricing provided before departure. Ideal for family and group pilgrimage."
    },
    {
      name: "One Way Cab Mumbai to Ashtavinayak",
      description:
        "Affordable one-way cab option for devotees planning return from a different location. Pay only for single-side distance. AC vehicles ensure relaxed long travel."
    },
    {
      name: "Round Trip Cab Mumbai to Ashtavinayak",
      description:
        "Flexible round-trip package covering all eight temples with return scheduling convenience. Transparent billing and safe highway travel guaranteed."
    },
    {
      name: "SUV Cab Mumbai to Ashtavinayak",
      description:
        "Spacious SUV cabs ideal for family and group pilgrimage travel. Comfortable seating and luggage space."
    },
    {
      name: "Luxury Cab Mumbai to Ashtavinayak",
      description:
        "Premium luxury vehicles for comfortable and executive pilgrimage journeys."
    },
    {
      name: "Mini Bus Mumbai to Ashtavinayak",
      description:
        "Mini bus options available for large groups and corporate spiritual tours."
    },
    {
      name: "Chauffeur Driven Cab Mumbai to Ashtavinayak",
      description:
        "Experienced drivers trained for temple route navigation and long-distance travel."
    },
    {
      name: "Online Cab Booking Mumbai to Ashtavinayak",
      description:
        "Easy online booking with instant confirmation and 24/7 support."
    }
  ],

  tableData: [
    ["Mumbai to Ashtavinayak Cab", "One Way Cab Mumbai to Ashtavinayak"],
    ["Round Trip Cab Mumbai to Ashtavinayak", "AC Cab Mumbai to Ashtavinayak"],
    ["Sedan Cab Mumbai to Ashtavinayak", "SUV Cab Mumbai to Ashtavinayak"],
    ["Luxury Cab Mumbai to Ashtavinayak", "Family Trip Cab Mumbai to Ashtavinayak"],
    ["Corporate Cab Mumbai to Ashtavinayak", "Weekend Trip Cab Mumbai to Ashtavinayak"],
    ["Mini Bus Mumbai to Ashtavinayak", "Chauffeur Driven Cab Mumbai to Ashtavinayak"],
    ["Budget Cab Mumbai to Ashtavinayak", "Same Day Return Cab Mumbai to Ashtavinayak"],
    ["Outstation Taxi Mumbai to Ashtavinayak", "Per Km Rate Cab Mumbai to Ashtavinayak"],
    ["Best Cab Service Mumbai to Ashtavinayak", "Group Tour Cab Mumbai to Ashtavinayak"]
  ],

  whychoose: [
    { WhyChooseheading: "Experienced Temple Route Drivers", WhyChoosedescription: "Our chauffeurs are familiar with all Ashtavinayak temple routes ensuring safe and punctual darshan visits." },
    { WhyChooseheading: "Transparent Pricing", WhyChoosedescription: "Clear per-kilometer fare calculation with no hidden charges." },
    { WhyChooseheading: "Flexible Yatra Packages", WhyChoosedescription: "One-day, two-day, and customized temple tour packages available." },
    { WhyChooseheading: "Comfortable AC Vehicles", WhyChoosedescription: "Fully air-conditioned sedans and SUVs for long-distance travel." },
    { WhyChooseheading: "24/7 Booking Support", WhyChoosedescription: "Round-the-clock assistance for bookings and travel coordination." },
    { WhyChooseheading: "Safe & Sanitized Fleet", WhyChoosedescription: "Well-maintained vehicles regularly cleaned and serviced." },
    { WhyChooseheading: "Group Travel Options", WhyChoosedescription: "Mini bus and SUV options available for large families and groups." },
    { WhyChooseheading: "Punctual Pickup Service", WhyChoosedescription: "On-time pickup from anywhere in Mumbai including airport and residences." }
  ]
};

const faqData = [
  { question: "How many days are required for Ashtavinayak Yatra?", answer: "Typically 1–2 days depending on travel plan and darshan schedule." },
  { question: "Is one-way cab available?", answer: "Yes, affordable one-way cab service available." },
  { question: "Are SUVs available?", answer: "Yes, spacious SUVs available for group pilgrimage travel." },
  { question: "Is mini bus available?", answer: "Yes, mini bus available for large group temple tours." },
  { question: "Is AC included?", answer: "Yes, all vehicles are air-conditioned." },
  { question: "Are fares transparent?", answer: "Yes, per-km pricing shared before confirmation." },
  { question: "Is online booking available?", answer: "Yes, instant online booking available 24/7." },
  { question: "Is same-day return possible?", answer: "Yes, same-day return packages are available." },
  { question: "Are drivers experienced?", answer: "Yes, drivers are experienced in temple route travel." },
  { question: "Is customer support 24/7?", answer: "Yes, support team available round-the-clock." }
];

const testimonials = [
  { id: 1, name: "Mr. Prakash Mehta", feedback: "Very smooth Ashtavinayak Yatra experience from Mumbai. Comfortable SUV and punctual driver.", rating: 5 },
  { id: 2, name: "Mrs. Kavita Shah", feedback: "Booked family pilgrimage trip. AC vehicle and professional service.", rating: 5 },
  { id: 3, name: "Corporate Group", feedback: "Organized group temple tour with mini bus. Excellent coordination.", rating: 5 },
  { id: 4, name: "Mr. Rohit Jain", feedback: "Affordable pricing and transparent billing for complete yatra.", rating: 5 },
  { id: 5, name: "Mrs. Snehal Patil", feedback: "Safe and devotional travel experience with Lotus Cab.", rating: 5 }
];


































































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ashtavinayak Darshan Cab Service",
  "image": "https://lotuscab.com/assets/images/mumbai-ashtavinayak-cab.jpg",
  "description": "Book Mumbai to Ashtavinayak Darshan Cab with Lotus Cab. Choose from AC, sedan, SUV, luxury cabs, Mini Bus, or chauffeur-driven rides for one-way, round trips, family trips, corporate travel, weekend trips, picnic trips, and group tours. Affordable per km rates and same-day return options available.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "690"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "500",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/mumbai-ashtavinayak-cab"
  }
};




  return (
    <div>
      

<Helmet>
  <title>Mumbai to Ashtavinayak Darshan Cab | Lotus Cab | Call +91 8767592195</title>
  <meta 
    name="description" 
    content="Book Mumbai to Ashtavinayak Darshan Cab with Lotus Cab. AC, sedan, SUV, luxury cabs, Mini Bus & chauffeur-driven rides for one-way, round trips, family trips, corporate travel, weekend trips & group tours. Affordable per km rates. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Ashtavinayak Cab, One Way Cab Mumbai to Ashtavinayak, Round Trip Cab Mumbai to Ashtavinayak, AC Cab Mumbai to Ashtavinayak, Sedan Cab Mumbai to Ashtavinayak, SUV Cab Mumbai to Ashtavinayak, Luxury Cab Mumbai to Ashtavinayak, Family Trip Cab Mumbai to Ashtavinayak, Corporate Cab Mumbai to Ashtavinayak, Weekend Trip Cab Mumbai to Ashtavinayak, Online Cab Booking Mumbai to Ashtavinayak, Mini Bus Mumbai to Ashtavinayak, Chauffeur Driven Cab Mumbai to Ashtavinayak, Picnic Trip Cab Mumbai to Ashtavinayak, Budget Cab Mumbai to Ashtavinayak, Same Day Return Cab Mumbai to Ashtavinayak, Outstation Taxi Mumbai to Ashtavinayak, Per Km Rate Cab Mumbai to Ashtavinayak, Best Cab Service Mumbai to Ashtavinayak, Group Tour Cab Mumbai to Ashtavinayak" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/70.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoashtavinayakdarshancabservice;